import { CHART_CARD_INFO_TOOLTIP_POPPER_CONFIG } from '@frontend/chart/components';
import { useId } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { LuInfo } from 'react-icons/lu';
import { FormattedMessage, useIntl } from 'react-intl';

const TOOLTIP_CLASS_NAME =
    'border-border-default bg-background-surface z-1000 max-w-sm rounded-md border shadow-sm [&_.tooltip-inner]:bg-background-surface [&_.tooltip-inner]:text-foreground-default [&_.tooltip-inner]:max-w-sm [&_.tooltip-inner]:p-0 [&_.tooltip-inner]:text-start';

export const ProofOfIdentityInfoIcon = () => {
    const intl = useIntl();
    const tooltipId = useId().replace(/:/g, '');

    return (
        <OverlayTrigger
            placement='top'
            flip
            delay={{ show: 300, hide: 150 }}
            popperConfig={CHART_CARD_INFO_TOOLTIP_POPPER_CONFIG}
            overlay={
                <Tooltip
                    id={tooltipId}
                    className={TOOLTIP_CLASS_NAME}>
                    <div className='p-3 text-sm'>
                        <div className='text-foreground-default mb-1 font-semibold'>
                            <FormattedMessage
                                id='platform.transaction.modal.proof-of-identity.info-what-heading'
                                description='Heading in the proof-of-identity card info tooltip describing what the card shows'
                                defaultMessage='What you are seeing'
                            />
                        </div>
                        <div className='text-foreground-muted'>
                            <FormattedMessage
                                id='platform.transaction.modal.proof-of-identity.info-what-body'
                                description='End-user explanation of the proof-of-identity card listing actions and locations that require identity proof'
                                defaultMessage='The specific actions along with their location (if available) where proof of identity is required to perform that action.'
                            />
                        </div>
                    </div>
                </Tooltip>
            }>
            <span
                className='text-foreground-muted hover:text-foreground-default inline-flex shrink-0 cursor-help'
                role='img'
                aria-label={intl.formatMessage({
                    id: 'platform.transaction.modal.proof-of-identity.info-aria-label',
                    description: 'Accessible label for the proof-of-identity card information icon',
                    defaultMessage: 'Proof of identity information'
                })}>
                <LuInfo className='size-4' />
            </span>
        </OverlayTrigger>
    );
};
